import { useDispatch } from "react-redux";

import SkeletonLineWrapper from "../SkeletonWrapper/SkeletonLineWrapper";

import { MeasuringSystem, Target } from "../../store/Session/SessionModel";
import { formatTargetDistance } from "../../store/Session/helper/UnitConversions";
import sessionSlice from "../../store/Session/SessionSlice";

import StackClubIcons from "../StackClubIcons/StackClubIcons";
import TargetTiles from "../TargetTiles/TargetTiles";
import ToggleTarget from "../ToggleTarget/ToggleTarget";
import "./style.css";
interface Props {
  target: Target;
  tabSelected: "ball-data" | "club-data" | "key-data";
  measuringSystem: MeasuringSystem;
}

const TargetModuleKeyData = ({ target, tabSelected, measuringSystem }: Props): JSX.Element => {
  const dispatch = useDispatch();

  const setIsShowShots = (isShowShots: boolean) => {
    if (target.isActive) {
      dispatch(
        sessionSlice.actions.setIsShowShots({
          isShowShots,
          clubId: target.targetId
        })
      );
    }
  };
  return (
    <div
      className={`target module-key-data module-key-data-instance-inactive-${!target.isActive}`}
    >
      <div className="frame">
        <div className="club">
          <ToggleTarget target={target} />
          <div className="club-yard">
            <SkeletonLineWrapper>
              <img
                alt="target-icon"
                className="target-icon"
                src="/img/combine/fs_target.png"
              />
              <span>
                {formatTargetDistance(target?.drillTarget?.distance.distance, measuringSystem)}
              </span>
            </SkeletonLineWrapper>
          </div>
        </div>
        <StackClubIcons target={target} />

        <div className="frame-shots">
          <div
            className="shot-count"
            onClick={() => setIsShowShots(!target.isShowShots)}
          >
            <img
              className="arrow"
              alt=""
              src={
                target.isShowShots
                  ? "/img/fs_arrow-down.svg"
                  : "/img/fs_arrow.svg"
              }
            />
            <div className="shot-count-text">
              <SkeletonLineWrapper>{`${target.totalShots} Shots`}</SkeletonLineWrapper>
            </div>
          </div>
          <div className="avg-text">AVG</div>
          <div className="avg-shot-count-text">
            <SkeletonLineWrapper>
              <div>{`${target.totalShots} Shots`}</div>
              <div className="toggle-shots" onClick={() => setIsShowShots(!target.isShowShots)}>
                <img
                  className="arrow"
                  width={20}
                  alt=""
                  src={
                    target.isShowShots
                      ? "/img/fs_arrow-down.svg"
                      : "/img/fs_arrow.svg"
                  }
                />
              </div>
            </SkeletonLineWrapper>
          </div>
        </div>
      </div>
      <TargetTiles tabSelected={tabSelected} target={target} />
    </div>
  );
};

export default TargetModuleKeyData;
